import Vue from 'vue'
import {Api} from '../utils/api'

const SetConfig  = async function (url, apiList) {
  let res = await Api('GetWechatConfig',{Url:url})
  Vue.wechat.config({
    debug: false,
    appId: res.app_id,
    timestamp: res.timestamp,
    nonceStr: res.nonce_str,
    signature: res.signature,
    jsApiList: apiList
  })
}

const SetShare  = function (options) {
  Vue.wechat.onMenuShareTimeline({
    title: options.title || '',
    link: options.url,
    imgUrl: options.image || '',
    success: function () {
    },
    cancel: function () {
    }
  })

  Vue.wechat.onMenuShareAppMessage({
    title: options.title || '',
    desc: options.desc,
    link: options.url,
    imgUrl: options.image || '',
    type: '',
    dataUrl: '',
    success: function () {
    },
    cancel: function () {
    }
  })
}


export {SetConfig, SetShare}
